<template>
    <section v-if="$role.restricAccess($route.name, 'view')">
        <breadcrumb-template :headtitle="$route.meta.title" :breadcrumbcurrent="$route.meta.title"></breadcrumb-template>
        <v-card class="card-outline force-remove-box">
            <v-card-text class="force-custom-bg">
                <v-container fluid>
                    <v-row dense no-gutters class="mb-5 text-center text-md-left subtitle-1">
                        <v-col cols="12" lg="2">
                            Total collections: <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> <strong>{{ totalCollections | toNumberWithDecimal }}</strong>
                        </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-end mt-n2">
                        
                        <v-col cols="12" md="6" lg="5" xl="2">
                            <v-text-field clearable dense outlined v-model="dt_searchQuery" label="Search"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="1" :class="($vuetify.breakpoint.mobile) ? 'mb-2':''">
                            <v-btn color="custom_info" class="float-right btn-block" @click="getDataFromApi()"><v-icon>mdi-magnify</v-icon></v-btn>
                        </v-col>

                        <v-col cols="12" md="3" lg="3" xl="2">
                            <v-btn color="custom_info" class="float-right btn-block" @click="modalForm()">Load credit</v-btn>
                        </v-col>

                        <v-col cols="12" class="mt-2">
                            <v-data-table class="custom-header-color table-bordered table-striped" :headers="dt_headers" :items="dt_resultlist" item-key="id" :loading="dt_loading"  :options.sync="dt_options" :server-items-length="dt_totalResult">
                                
                                <!-- <template v-slot:[`item.status`]="{ item }">{{ (item.status == 1) ? 'Active':'Inactive' }}</template> -->

                                <template v-slot:[`item.debit`]="{ item }"> <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> {{ (item.debit == null) ? 0.00 : item.debit | toNumberWithDecimal }}</template>

                                <template v-slot:[`item.actions`]="{ item }" v-if="$role.restricAccess($route.name, 'edit')">
                                    <v-btn-toggle block rounded>
                                        <v-btn color="info" dark small @click="modalForm(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                                        <!-- <v-btn color="error" dark small @click="deleteData(item.id)"><v-icon>mdi-delete</v-icon></v-btn> -->
                                    </v-btn-toggle>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <section>
            <v-dialog v-model="dialogForm" width="600px" scrollable persistent>
                <v-card class="card-outline custom-color-dialog">
                    <v-card-title class="headline headline_bg">
                        <span v-if="modalUpdate">Update agent credit status</span>
                        <span v-else>Load agent credit</span>
                    </v-card-title>

                    <v-card-text>
                        <v-row no-gutters class="pt-6">
                            <v-col cols="12" class="form-col">
                                <agent-credit-autocomplete-template v-if="!modalUpdate" ref="agent_autocomplete"></agent-credit-autocomplete-template>
                                <v-text-field v-else dense outlined v-model="form.username" label="Sub-agent" :disabled="true"></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="form-col">
                                <v-text-field dense outlined v-model="form.amount" type="number" label="Amount" :error-messages="formerror.amount" :disabled="(modalUpdate) ? true:false"></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="form-col">
                                <!-- <v-switch dense inset v-model="form.status" label="Status"></v-switch> -->
                                <v-select hide-details outlined dense clearable :items="['Paid', 'Unpaid']" label="Status" v-model="form.status" :error-messages="formerror['status']"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="actionButtons pt-6">
                        <v-row no-gutters>
                            <v-col cols="6" lg="6" class="px-2">
                                <v-btn color="custom_error" @click="dialogForm = false">Close</v-btn>
                            </v-col>
                            <v-col cols="6" lg="6" class="px-2">
                                <span v-if="$role.restricAccess($route.name, 'edit')"><v-btn color="info" class="float-right" @click="updateData" v-if="modalUpdate" :loading="isLoadingBtn">Update</v-btn></span>
                                <v-btn color="custom_info" class="float-right" @click="newData" v-if="!modalUpdate" :loading="isLoadingBtn">Save</v-btn>
                                <!-- <v-btn color="info" class="float-right mr-3" :loading="isLoadingBtn" dark @click="newData">Save</v-btn> -->
                            </v-col>
                        </v-row>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </section>

        <confirm-dialog ref="confirm"></confirm-dialog>

    </section>
</template>

<script>
    export default {
        data(){
            return{
                dialogForm: false,
                isLoadingBtn: false,
                isLoadingBtnDelete: false,
                formerror: {},
                modalUpdate: false,
                dt_headers: [
                    { text: 'Account #', value: 'account_no', name: 'account_no', sortable: false, searchable: true},
                    { text: 'Username', value: 'username', name: 'username', sortable: false, searchable: true},
                    { text: 'Contact #', value: 'mobilenumber', name: 'mobilenumber', sortable: false, searchable: true},
                    { text: 'Top-up date', value: 'date_created', name: 'date_created', sortable: false, searchable: true},
                    { text: 'Credit', value: 'debit', name: 'debit', sortable: false, searchable: true},
                    { text: 'Status', value: 'status', name: 'status', sortable: false, searchable: true},
                    { text: 'Action', value: 'actions', sortable: false, searchable: false, width: '10%'},
                ],
                dt_options: {},
                dt_columns:{},
                dt_totalResult: 0,
                dt_searchInput: '',
                dt_searchQuery: "",
                dt_resultlist: [],
                dt_loading: true,
                dt_itemsPerPage: 50,
                dt_reload: '',
                form: new this.$Form({
                    id: null,
                    agent_id: null,
                    username: null,
                    amount: 0,
                    bet: 0,
                    status: null
                }),
                totalCollections: 0,
            };
        },
        methods:{
            async modalForm(data){
                this.form.reset();
                if(data){
                    this.modalUpdate = true;
                    this.form.fill(data);
                    this.form.amount = data.debit;
                    
                    this.dialogForm = true;
                    await new Promise(resolve => setTimeout(resolve, 300));
                    this.$refs.agent_autocomplete.isupdatesearch(data.username);
                }else{
                    this.modalUpdate = false;
                    this.dialogForm = true;
                    await new Promise(resolve => setTimeout(resolve, 300));
                    this.$refs.agent_autocomplete.autocomplete_model = [];
                    this.$refs.agent_autocomplete.autocomplete_search = '';
                }
            },
            newData(){
                let agent_autocomplete = this.$refs.agent_autocomplete.autocomplete_model;
                if(!agent_autocomplete || agent_autocomplete.length <= 0){
                    this.$refs.agent_autocomplete.errorwatcher('error');
                    return;
                }else{
                    this.$refs.agent_autocomplete.errorwatcher('success');
                }
                this.form.agent_id = agent_autocomplete.id;

                this.form
                .post(this.$_CONFIG.api('API_LOAD_AGENT'))
                .then(({ data }) => {
                    this.isLoadingBtn = false;
                    this.getDataFromApi();
                    this.dialogForm = false;
                    this.$Swal.fire("Success!", "Record has been successfully added.", "success");
                })
                .catch((error) => {
                    this.isLoadingBtn = false;
                    this.formerror = error.response.data;
                    this.$toast.fire({ icon: 'error', title: "Something went wrong!" });
                });
            },
            updateData(){
                this.isLoadingBtn = true;
                this.form
                .put(this.$_CONFIG.api('API_LOAD_AGENT') + "/" + this.form.id)
                .then(() => {
                    this.isLoadingBtn = false;
                    this.dialogForm = false;
                    this.getDataFromApi();
                    this.$Swal.fire("Updated!", "Record has been successfully updated.", "success");
                })
                .catch((error) => {
                    this.isLoadingBtn = false;
                    this.formerror = error.response.data;
                    this.$toast.fire({ icon: 'error', title: "Something went wrong!" });
                });
            },
            async deleteData(id){
                if(await this.$refs.confirm.open("Confirm", "Are you sure you want to delete all record?")){
                    this.form
                        .delete(this.$_CONFIG.api('API_LOAD_AGENT') + "/" + id)
                        .then(() => {
                            this.dialogForm = false;
                            this.getDataFromApi();
                            this.$Swal.fire("Deleted!", "Record has been successfully deleted", "success");
                        })
                        .catch(() => {
                            this.$toast.fire({ icon: 'error', title: "Something went wrong!" });
                        });
                }
            },
            paramsfilter(){
                return {
                    ...this.dt_options,
                    query: this.dt_searchQuery,
                };
            },
            async getDataFromApi() {
                this.dt_loading = true;
                var paramsfilter = await this.paramsfilter();
                this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
                let params = await this.$YajraDT.params(paramsfilter, this.dt_options, this.dt_itemsPerPage, this.dt_columns);
                let apiPath = await this.$_CONFIG.api('API_LOAD_AGENT');

                await this.$axios.get(apiPath + "?" + this.$.param(params)).then((res) => {
                    if(this.dt_totalResult != res.data.recordsFiltered){ this.dt_options.page = 1; }

                    this.dt_resultlist = res.data.data;
                    this.dt_totalResult = res.data.recordsFiltered;
                    this.dt_loading = false;
                }).catch((err) => {
                    this.dt_loading = false;
                    console.log("Error searching");
                });

                var unwatch = this.$watch('dt_options.page', function(newValue, oldValue) {
                    this.getDataFromApi();
                    unwatch();
                }, { deep: true });
            },
            // getDataFromApi() {
            //     this.dt_columns = this.$YajraDT.setHeader(this.dt_headers);
            //     this.dt_loading = true;
            //     return new Promise((resolve, reject) => {
                    
            //         let params = this.$YajraDT.params(this.params, this.dt_options, this.dt_itemsPerPage, this.dt_columns);
            //         let apiPath = this.$_CONFIG.api('API_LOAD_AGENT');

            //         this.$axios.get(apiPath + "?" + this.$.param(params)).then((res) => {

            //             if(this.$YajraDT.totalPageStore(apiPath + '_otrs', res.data.recordsFiltered)){ this.dt_options.page = 1; }
            //             localStorage.setItem(apiPath + '_otrs', res.data.recordsFiltered);

            //             this.dt_loading = false;

            //             let items = res.data.data;
            //             let total = res.data.recordsFiltered;
            //             let totalCollections = res.data.totalCollections;
                        
            //             resolve({
            //                 items,
            //                 total,
            //                 totalCollections
            //             });

            //         }).catch((err) => {
            //             this.dt_loading = false;
            //             console.log("Error searching");
            //         });
            //     });
            // },
        },
        // computed: {
        //     params(nv) {
        //         return {
        //             ...this.dt_options,
        //             query: this.dt_searchQuery,
        //             reload: this.dt_reload,
        //         };
        //     }
        // },
        // watch: {
        //     params: {
        //         handler() {
        //             this.getDataFromApi().then(data => {
        //                 this.dt_resultlist = data.items;
        //                 this.dt_totalResult = data.total;
        //                 this.totalCollections = data.totalCollections;
        //             });
        //         },

        //         deep: true
        //     },
        // },
        created(){
            this.getDataFromApi();
        },
        mounted() {
            
        }
    }
</script>
<style scoped>

</style>
